import { AuthContext, CommonContext } from '@repo-level/core-front';
import { DEFAULT_CURRENCIES } from 'helpers/conf';
import { isCryptoCurrency } from 'helpers/currency';
import { formatWalletValue } from 'helpers/wallet';
import { useContext, useMemo } from 'react';

export function useCurrentOptionWallet() {
  const { user, wallets } = useContext(AuthContext);

  const currentOptionWallet = useMemo(() => {
    const wallet =
      wallets.find(({ currency }) => currency === user?.currency) || wallets[0];
    return {
      ...wallet,
      isCrypto: isCryptoCurrency(DEFAULT_CURRENCIES, wallet?.currency),
    };
  }, [user, wallets]);

  return currentOptionWallet;
}

export function useFormatCurrentOptionWallet(withSymbol?: boolean) {
  const { currencies } = useContext(CommonContext);

  const { amountCents, currency: currencyCode } = useCurrentOptionWallet();

  return formatWalletValue(currencyCode, amountCents, currencies, withSymbol);
}

export function useMaxAmountValue() {
  const { currencies } = useContext(CommonContext);
  const { user, extendedWallets: wallets } = useContext(AuthContext);

  const currentOptionWallet = useMemo(() => {
    if (!wallets) return null;
    return (
      wallets.find(({ currency }) => currency === user?.currency) || wallets[0]
    );
  }, [user, wallets]);

  if (!currentOptionWallet) return null;

  const { currency, availableToCashoutCents } = currentOptionWallet;
  return formatWalletValue(
    currency,
    availableToCashoutCents,
    currencies
  ) as number;
}
